import { getGuideCategories, getGuides } from '@/graphql/queries/media/guide';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const categoryFromSlug = (slug) => {
    const key = `guides.categories.${slug}`;
    return { description: store.$i18n.t(`${key}.description`), name: store.$i18n.t(`${key}.name`), path: `/guides/${slug}/`, slug };
  };
  const breadcrumbs = [['i18n/home', '/']];
  const categorySlug = route.params.category;
  const locale = route.query.locale;
  const page = route.query.page;
  let description, jumboTitle, subtitle, title;

  await $apolloQuery(getGuideCategories).then(slugs => store.commit('blog/setCategories', slugs.map(slug => categoryFromSlug(slug))));
  await $apolloQuery(getGuides, { category: categorySlug, locale, page }).then(results => {
    if (results.category) {
      const category = categoryFromSlug(results.category);
      breadcrumbs.concat([['i18n/guides', '/guides/'], category.name]);
      jumboTitle = title = store.$i18n.t('guides.category.title', category);
      description = subtitle = category.description;
      store.commit('blog/setCategory', category);
    } else {
      breadcrumbs.push('i18n/guides');
      description = store.$i18n.t('guides.index.description');
      jumboTitle = store.$i18n.t('guides.index.jumbotron.title');
      title = store.$i18n.t('guides.index.title');
    }
    store.commit('blog/setGuides', results.guides);
    store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-blog-newsletter-signup', subtitle, title: jumboTitle, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('utils/setPagination', results.meta.pagination);
  });
};
